import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import InputConfig from '../../../../Components/InputConfig';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
//===============

const UamConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Uam Config"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Uam Config']}
				description="Manage Uam Config Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={1} style={{ marginTop: '4rem', marginLeft: '4rem', width: '90%' }}>
				<Grid item xs={2} style={{ marginTop: '4.5rem' }}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						label="Publisher Id"
						keyData={keyData + '.publisherId'}
						editable={!!rawConfig[keyData + '.enabled']}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						label="Uam Slot Id"
						keyData={keyData + '.uamSlotId'}
						editable={!!rawConfig[keyData + '.enabled']}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default UamConfig;
